import React, { useEffect, useState, useMemo, useRef } from "react";
import {
  getBalanceDefinitifDetails,
  getBalanceProvisoiresDetails,
} from "../../../../../../../data/balance/balance";
import { getListeExerciceClients } from "../../../../../../../data/exercice";
import {
  Button,
  Col,
  notification,
  Row,
  Table,
  Tooltip,
  Typography,
} from "antd";
import { SwapOutlined } from "@ant-design/icons";
import { appTheme } from "../../../../../../../config/theme";
import { faScaleBalanced, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TableTitle from "../../../../../../common/TableTitle";
import { SearchHeader } from "../../../../../../layout/header/HeaderList";
import { ModalTitle } from "../../../../../../modals/modals.components";
import ModalAlert from "../../../../../../modals/Modal";
import ReactToPrint from "react-to-print";

const { Text } = Typography;

const TraitementExamenAnalytiqueBilan = ({
  mission,
  setBalanceData,
  balanceData,
  setIsTaskSave,
  chargement,
  isProvisoire,
  client,
  fetchFeuilleMaitresse,
}) => {
  const [missionN_1, setMissionN_1] = useState(null);
  const [balanceDefN_1, setBalanceDefN_1] = useState([]);
  const [resbalance, setResbalance] = useState([]);
  const [selectedBalances, setSelectedBalances] = useState([]);
  const [modalBalance, setModalBalance] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalId, setModalId] = useState(1);
  const [title, setTitle] = useState("");
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 1000,
    },
  });
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ Référence pour l'impression
  const printRef = useRef();

  // ✅ AJOUT: Initialiser resbalance avec balanceData existant
  useEffect(() => {
    if (balanceData && balanceData.length > 0) {
      setResbalance(balanceData);
    }
  }, [balanceData]);

  useEffect(() => {
    if (mission) {
      const fetchBalanceProvisoireN = () => {
        setLoading(true);
        getBalanceProvisoiresDetails(mission.id).then((res) => {
          if (res.results) {
            setSelectedBalances(res.results.Lea_BalanceDetails);
          } else {
            setSelectedBalances([]);
          }
          setLoading(false);
        });
      };

      const fetchBalanceDefinitif = () => {
        setLoading(true);
        getBalanceDefinitifDetails(mission.id).then((res) => {
          if (res.results) {
            setSelectedBalances(res.results.Lea_BalanceDetails);
          } else {
            setSelectedBalances([]);
          }
          setLoading(false);
        });
      };

      // ✅ CORRECTION: Charger selon isProvisoire
      if (parseInt(isProvisoire) === 1) {
        fetchBalanceProvisoireN();
      } else {
        fetchBalanceDefinitif();
      }
    }
  }, [mission, isProvisoire]); // ✅ Ajouter isProvisoire aux dépendances

  useEffect(() => {
    if (client) {
      getListeExerciceClients(client.id).then((res) => {
        const missN1 = res.find(
          (opt) => parseInt(opt.annee) === parseInt(mission?.annee) - 1
        );
        setMissionN_1(missN1);
      });
    }
  }, [client, mission]);

  useEffect(() => {
    if (missionN_1) {
      const fetchBalanceDefinitifN_1 = () => {
        setLoading(true);
        getBalanceDefinitifDetails(missionN_1.id).then((res) => {
          if (res.results) {
            setBalanceDefN_1(res.results.Lea_BalanceDetails);
          } else {
            setBalanceDefN_1([]);
          }
          setLoading(false);
        });
      };

      fetchBalanceDefinitifN_1();
    }
  }, [missionN_1]);

  // ✅ AJOUT: useEffect pour génération automatique
  useEffect(() => {
    // Si on a des données existantes dans balanceData, les utiliser
    if (balanceData && balanceData.length > 0 && resbalance.length === 0) {
      setResbalance(balanceData);
      return;
    }

    // Sinon, générer automatiquement si les conditions sont remplies
    const shouldAutoGenerate =
      selectedBalances.length > 0 &&
      balanceDefN_1.length > 0 &&
      resbalance.length === 0 &&
      (!balanceData || balanceData.length === 0);

    if (shouldAutoGenerate) {
      console.log("Auto-génération des données...");
      handleResultatClick();
    }
  }, [selectedBalances, balanceDefN_1, balanceData]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  const handleResultatClick = () => {
    setLoading(true);
    setTimeout(() => {
      if (balanceData && balanceData.length > 0) {
        setBalanceData([]);
      }
      const bilanMap = new Map();

      selectedBalances.forEach((balance) => {
        const isExist = balanceDefN_1.find((item) =>
          item.numeroCompte.includes(balance.numeroCompte)
        );
        const soldeN =
          parseInt(balance.soldeDebit || 0) -
          parseInt(balance.soldeCredit || 0);
        const soldeN_1 = isExist
          ? parseInt(isExist.soldeDebit || 0) -
            parseInt(isExist.soldeCredit || 0)
          : 0;

        const newElement = {
          compte: balance.numeroCompte,
          libelle: balance.libelle,
          soldeN,
          soldeN_1,
          commentaire: "",
        };

        bilanMap.set(balance.numeroCompte, newElement);
      });

      balanceDefN_1.forEach((balance) => {
        const isExist = selectedBalances.find((item) =>
          item.numeroCompte.includes(balance.numeroCompte)
        );

        const existingElement = bilanMap.get(balance.numeroCompte);
        if (existingElement) {
          existingElement.soldeN_1 =
            parseInt(balance.soldeDebit || 0) -
            parseInt(balance.soldeCredit || 0);
        } else {
          const newElement = {
            compte: balance.numeroCompte,
            libelle: balance.libelle,
            soldeN: isExist
              ? parseInt(isExist.soldeDebit || 0) -
                parseInt(isExist.soldeCredit || 0)
              : 0,
            soldeN_1:
              parseInt(balance.soldeDebit || 0) -
              parseInt(balance.soldeCredit || 0),
            commentaire: "",
          };

          bilanMap.set(balance.numeroCompte, newElement);
        }
      });

      const updateBalance = [...bilanMap.values()];
      const sortedBalance = updateBalance.sort((a, b) =>
        a.compte.localeCompare(b.compte)
      );

      setBalanceData(sortedBalance);
      setResbalance(sortedBalance);

      setIsTaskSave((prevState) => [...prevState, 2]);
      notification.warning({
        /* message: "Données générées", */
        description: "Données envoyées avec succès à l'historique Balances !",
      });

      setLoading(false);
    }, 1000);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value || "";
    setSearchTerm(value);
  };

  const handleModalOpen = (id, balances, title) => {
    setModalId(id);
    setModalBalance(balances);
    setTitle(title);
    setIsModalOpen((prevState) => !prevState);
  };

  const columnsModal = [
    {
      title: () => <TableTitle>#</TableTitle>,
      render: (_, record, index) => <>{index + 1}</>,
      width: 40,
    },
    {
      title: () => <TableTitle>Compte</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <span className="fw-bolder" style={{ fontSize: "14px" }}>
          {record.numeroCompte}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Libellé</TableTitle>,
      dataIndex: "col1",
      width: 400,
      render: (_, record) => (
        <span className="fw-bolder" style={{ fontSize: "14px" }}>
          {record.libelle}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Débit</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {(record.soldeDebit || 0).toLocaleString("fr")}
        </div>
      ),
    },

    {
      title: () => <TableTitle>Crédit</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {(record.soldeCredit || 0).toLocaleString("fr") || 0}
        </div>
      ),
    },

    {
      title: () => <TableTitle>Solde</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {(
            (record.soldeDebit || 0) - (record.soldeCredit || 0)
          ).toLocaleString("fr") || 0}
        </div>
      ),
    },
  ];

  const columnResBalance = [
    {
      title: () => <TableTitle>#</TableTitle>,
      render: (_, record, index) => <>{index + 1}</>,
      width: 40,
    },
    {
      title: () => <TableTitle>Compte</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <span className="fw-bolder" style={{ fontSize: "14px" }}>
          {record.compte}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Libellé</TableTitle>,
      dataIndex: "col1",
      width: 400,
      render: (_, record) => (
        <span className="fw-bolder" style={{ fontSize: "14px" }}>
          {record.libelle}
        </span>
      ),
    },
    {
      title: () => (
        <TableTitle>{`Exercice ${mission.annee || "N"}`}</TableTitle>
      ),
      dataIndex: "soldeN",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {(record.soldeN || 0).toLocaleString("fr") || 0}
        </div>
      ),
    },
    {
      title: () => (
        <TableTitle>{`Exercice ${
          parseInt(mission.annee) - 1 || "N-1"
        } `}</TableTitle>
      ),
      dataIndex: "soldeN_1",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {(record.soldeN_1 || 0).toLocaleString("fr") || 0}
        </div>
      ),
    },
    {
      title: () => <TableTitle>N - N-1</TableTitle>,
      key: "brut",
      dataIndex: "brut",
      children: [
        {
          title: () => <TableTitle>VARIATION</TableTitle>,
          dataIndex: "col1",
          width: 100,
          render: (_, record) => (
            <div
              className={`text-end p-1 fw-bolder 
                                        ${
                                          (
                                            (record.soldeN === 0
                                              ? 0
                                              : (record.soldeN -
                                                  record.soldeN_1) /
                                                record.soldeN_1) * 100
                                          ).toFixed(2) >= 10
                                            ? "bg-danger text-white"
                                            : ""
                                        }
                                        ${
                                          (
                                            (record.soldeN === 0
                                              ? 0
                                              : (record.soldeN -
                                                  record.soldeN_1) /
                                                record.soldeN_1) * 100
                                          ).toFixed(2) <= -10
                                            ? "bg-danger text-white"
                                            : ""
                                        }
                                       `}
              style={{ fontSize: "14px" }}
            >
              {(record.soldeN - record.soldeN_1).toLocaleString("fr")}
            </div>
          ),
        },
        {
          title: () => <TableTitle>% Variation</TableTitle>,
          dataIndex: "col1",
          width: 70,
          render: (_, record) => (
            <div
              className={`text-end p-1 fw-bolder 
                                        ${
                                          (
                                            (record.soldeN === 0
                                              ? 0
                                              : (record.soldeN -
                                                  record.soldeN_1) /
                                                record.soldeN_1) * 100
                                          ).toFixed(2) >= 10
                                            ? "bg-danger text-white"
                                            : ""
                                        }
                                        ${
                                          (
                                            (record.soldeN === 0
                                              ? 0
                                              : (record.soldeN -
                                                  record.soldeN_1) /
                                                record.soldeN_1) * 100
                                          ).toFixed(2) <= -10
                                            ? "bg-danger text-white"
                                            : ""
                                        }
                                       `}
              style={{ fontSize: "14px" }}
            >
              {(
                (record.soldeN_1 === 0
                  ? 0
                  : (record.soldeN - record.soldeN_1) / record.soldeN_1) * 100
              )
                .toFixed(2)
                .toLocaleString("fr")}
              %
            </div>
          ),
        },
      ],
    },
  ];

  const filteredResBalance = useMemo(() => {
    if (!searchTerm || typeof searchTerm !== "string" || !searchTerm.trim()) {
      return resbalance;
    }

    const searchTermLower = searchTerm.toLowerCase().trim();

    return resbalance.filter((item) => {
      const compteMatch = item.compte
        ?.toString()
        .toLowerCase()
        .includes(searchTermLower);
      const libelleMatch = item.libelle
        ?.toLowerCase()
        .includes(searchTermLower);
      const commentaireMatch = item.commentaire
        ?.toLowerCase()
        .includes(searchTermLower);

      return compteMatch || libelleMatch || commentaireMatch;
    });
  }, [resbalance, searchTerm]);

  return (
    <>
      <div className="py-5">
        <Row gutter={[16, 16]}>
          <Col
            xs={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 20 }}
            xl={{ span: 20 }}
          >
            <div className="d-flex flex-wrap align-items-center">
              <div className="me-10">
                <Tooltip
                  title={`Balance ${
                    parseInt(isProvisoire) === 1 ? "provisoire" : "définitive"
                  } ${mission.annee || "N"}`}
                >
                  <Button
                    size={"large"}
                    loading={loading}
                    style={{
                      backgroundColor: appTheme.colors.primary,
                      color: "white",
                    }}
                    icon={
                      <FontAwesomeIcon
                        style={{ paddingRight: "10" }}
                        icon={faScaleBalanced}
                      />
                    }
                    onClick={() =>
                      handleModalOpen(
                        1,
                        selectedBalances,
                        `${
                          parseInt(isProvisoire) === 1
                            ? "provisoire"
                            : "définitive"
                        }`
                      )
                    }
                  >
                    <span className="indicator-label text-white fs-6 fw-bolder">{`Balance ${
                      parseInt(isProvisoire) === 1 ? "provisoire" : "définitive"
                    } ${mission.annee || "N"}`}</span>
                  </Button>
                </Tooltip>
              </div>
              <div className="">
                <Tooltip
                  title={`Balance définitive ${
                    parseInt(missionN_1?.annee) || "N-1"
                  }`}
                >
                  <Button
                    size={"large"}
                    loading={loading}
                    style={{
                      backgroundColor: appTheme.colors.secondary,
                      color: "white",
                    }}
                    icon={
                      <FontAwesomeIcon
                        style={{ paddingRight: "10" }}
                        icon={faScaleBalanced}
                      />
                    }
                    onClick={() =>
                      handleModalOpen(
                        2,
                        balanceDefN_1,
                        `${isProvisoire === 1 ? "provisoire" : "définitive"}`
                      )
                    }
                  >
                    <span className="indicator-label text-white">{`Balance définitive ${
                      parseInt(missionN_1?.annee) || "N-1"
                    }`}</span>
                  </Button>
                </Tooltip>
              </div>
            </div>
          </Col>
          <Col
            xs={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
          >
            <Tooltip title="Résultats">
              <Button
                disabled={
                  mission.isCloture === 1 || mission.isClotureProvisoire === 1
                }
                size={"large"}
                loading={loading}
                style={{
                  backgroundColor: appTheme.colors.primary_blue,
                  color: "white",
                }}
                icon={
                  <SwapOutlined
                    style={{ fontSize: "20px", marginRight: "5px" }}
                  />
                }
                onClick={handleResultatClick}
              >
                {!loading && (
                  <span className="indicator-label text-white">Résultats</span>
                )}
                {loading && (
                  <span className="indicator-progress text-white">
                    Patientez svp...
                  </span>
                )}
              </Button>
            </Tooltip>
          </Col>
        </Row>
        <div className="table-responsive">
          {(resbalance ?? []).length > 0 && (
            <div className="card-header border-0 pt-2">
              <SearchHeader
                placeholder="Rechercher par la référence, le libellé..."
                handleSearch={handleSearchChange}
                value={searchTerm || ""} // ✅ Valeur contrôlée avec fallback
              />
            </div>
          )}
          <div className="py-4">
            {/* ✅ AJOUT: Message si pas de données */}
            {resbalance.length === 0 && !loading && (
              <div className="text-center py-5">
                <div className="text-muted">
                  <i className="fas fa-table fa-3x mb-3"></i>
                  <p className="fs-5">
                    {selectedBalances.length === 0 || balanceDefN_1.length === 0
                      ? "Chargement des données de balance en cours..."
                      : "Cliquez sur 'Résultats' pour générer la comparaison"}
                  </p>
                </div>
              </div>
            )}

            {/* ✅ Tableau affiché seulement si données disponibles */}
            {resbalance.length > 0 && (
              <div className="table-responsive">
                <Table
                  rowClassName={(record) =>
                    `${
                      record.color ? `bg-${record?.color}` : ""
                    } h-3px p-0 m-0 lh-0.5`
                  }
                  columns={columnResBalance}
                  rowKey={(record, index) => index}
                  dataSource={filteredResBalance ?? []}
                  pagination={tableParams.pagination}
                  onChange={handleTableChange}
                  loading={chargement}
                  rowSelection
                  size={"small"}
                  summary={(pageData) => {
                    let totalSoldeN = 0;
                    let totalSoldeN_1 = 0;
                    let totalVariation = 0;
                    let totalPourcVariation = 0;
                    pageData.forEach(({ soldeN, soldeN_1 }) => {
                      totalSoldeN += soldeN || 0;
                      totalSoldeN_1 += soldeN_1 || 0;
                      totalVariation += (soldeN || 0) - (soldeN_1 || 0);
                      totalPourcVariation +=
                        (soldeN_1 || 0) === 0
                          ? 0
                          : (((soldeN || 0) - (soldeN_1 || 0)) /
                              (soldeN_1 || 1)) *
                            100;
                    });
                    return (
                      <Table.Summary fixed>
                        <Table.Summary.Row>
                          <Table.Summary.Cell index={0}></Table.Summary.Cell>
                          <Table.Summary.Cell index={1}></Table.Summary.Cell>
                          <Table.Summary.Cell index={2}>
                            Total Extrait
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={3} className="text-end">
                            <Text type="success">{""}</Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={4} className="text-end">
                            <Text type="success">
                              {totalSoldeN.toLocaleString("fr")}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={5} className="text-end">
                            <Text type="success">
                              {totalSoldeN_1.toLocaleString("fr")}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={6} className="text-end">
                            <Text type="success">
                              {totalVariation.toLocaleString("fr")}
                            </Text>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={7} className="text-end">
                            <Text type="success">
                              {(
                                totalPourcVariation / (pageData.length || 1)
                              ).toFixed(2)}
                              %
                            </Text>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </Table.Summary>
                    );
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <ModalAlert
        closeModal={handleModalOpen}
        show={isModalOpen}
        title={
          <ModalTitle>
            <div className="d-flex justify-content-between align-items-center">
              <span>
                Balance {title || ""}{" "}
                {modalId === 1
                  ? mission.annee || "N"
                  : missionN_1.annee || "N-1"}{" "}
              </span>
              <span className="me-8">
                <ReactToPrint
                  key="print-pdf"
                  trigger={() => (
                    <Button
                      type="default"
                      size="large"
                      icon={<FontAwesomeIcon icon={faFilePdf} />}
                      style={{
                        backgroundColor: "#dc3545",
                        borderColor: "#dc3545",
                        color: "white",
                        marginRight: "100px",
                      }}
                    >
                      Exporter PDF
                    </Button>
                  )}
                  content={() => printRef.current}
                  documentTitle={`Balance_${title}_${
                    modalId === 1 ? mission.annee : missionN_1?.annee
                  }_${client?.denomination || ""}`}
                  pageStyle={`
                  @page {
                    size: A4 landscape /* portrait */; 
                    margin: 10mm;
                    @bottom-center {
                      content: "Page " counter(page) " sur " counter(pages);
                      font-size: 10px;
                      text-align: center;
                      color: #666;
                    }
                  }
                  @media print {
                  body { 
                    font-size: 10px; 
                    line-height: 1.2;
                  }
                  .ant-table { 
                    font-size: 8px; 
                    border-collapse: collapse;
                  }
                  .ant-table-thead > tr > th {
                    font-size: 9px;
                    padding: 4px !important;
                    /* border: 1px solid #ddd !important; */
                  }
                  .ant-table-tbody > tr > td {
                    font-size: 8px;
                    padding: 3px !important;
                    /* border: 1px solid #ddd !important; */
                  }
                  .ant-table-summary tr td {
                    font-weight: bold !important;
                    background-color: #f0f0f0 !important;
                    /* border: 1px solid #ddd !important; */
                  }
                  .text-end {
                    text-align: right !important;
                  }
                  .print-header {
                    display: block !important;
                    text-align: center;
                    margin-bottom: 20px;
                    border-bottom: 2px solid #333;
                    padding-bottom: 10px;
                  }
                  /* ✅ AJOUTÉ: Retirer le scroll lors de l'impression */
                  .ant-table-wrapper {
                    overflow: visible !important;
                  }
                  .ant-table {
                    overflow: visible !important;
                  }
                  .ant-table-content {
                    overflow: visible !important;
                    height: auto !important;
                    max-height: none !important;
                  }
                  .ant-table-body {
                    overflow: visible !important;
                    height: auto !important;
                    max-height: none !important;
                  }
                  .table-responsive {
                    overflow: visible !important;
                  }
                  }
                `}
                  onBeforeGetContent={() => {
                    return new Promise((resolve) => {
                      setTimeout(resolve, 300);
                    });
                  }}
                  onAfterPrint={() => {
                    notification.success({
                      message: "Export PDF réussi",
                      description: "Le document PDF a été généré avec succès",
                      duration: 3,
                    });
                  }}
                  onPrintError={(errorLocation, error) => {
                    console.error("Erreur d'impression:", error);
                    notification.error({
                      message: "Erreur d'export PDF",
                      description:
                        "Impossible de générer le PDF. Veuillez réessayer.",
                      duration: 5,
                    });
                  }}
                />
              </span>
            </div>
          </ModalTitle>
        }
        footer={
          [
            // ✅ Bouton d'impression PDF
          ]
        }
        modalStyles={{ top: 30 }}
        width={1000}
      >
        <div className="py-4" ref={printRef}>
          {/* ✅ Header pour l'impression (caché par défaut) */}
          <div style={{ display: "none" }} className="print-header">
            <h2>
              Balance {title} -{" "}
              {modalId === 1 ? mission.annee : missionN_1?.annee}
            </h2>
            <p style={{ fontSize: "12px", color: "#666", margin: "5px 0" }}>
              Client: {client?.denomination} | Généré le{" "}
              {new Date().toLocaleDateString("fr-FR")} à{" "}
              {new Date().toLocaleTimeString("fr-FR")}
            </p>
          </div>

          <div className="table-responsive">
            <Table
              rowClassName={(record) =>
                `${
                  record.color ? `bg-${record?.color}` : ""
                } h-3px p-0 m-0 lh-0.5`
              }
              columns={columnsModal}
              rowKey={(record, index) => index}
              dataSource={modalBalance}
              pagination={false}
              // ✅ MODIFIÉ: Retirer scroll lors de l'impression
              scroll={{ y: 500 }}
              loading={chargement}
              size={"small"}
              summary={(pageData) => {
                let totalSoldeCredit = 0;
                let totalSoldeDebit = 0;
                let totalSoldeN = 0;
                pageData.forEach(({ soldeDebit, soldeCredit }) => {
                  totalSoldeDebit += soldeDebit || 0;
                  totalSoldeCredit += soldeCredit || 0;
                  totalSoldeN += (soldeDebit || 0) - (soldeCredit || 0);
                });
                return (
                  <Table.Summary fixed>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={2}>
                        <strong>Total</strong>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={3} className="text-end">
                        <Text type="success">{""}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4} className="text-end">
                        <Text type="success" style={{ fontSize: "12px" }}>
                          <strong>
                            {totalSoldeDebit.toLocaleString("fr")}
                          </strong>
                        </Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={5} className="text-end">
                        <Text type="success" style={{ fontSize: "12px" }}>
                          <strong>
                            {totalSoldeCredit.toLocaleString("fr")}
                          </strong>
                        </Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={6} className="text-end">
                        <Text type="success" style={{ fontSize: "12px" }}>
                          <strong>{totalSoldeN.toLocaleString("fr")}</strong>
                        </Text>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
            />
          </div>
        </div>
      </ModalAlert>
    </>
  );
};

export default TraitementExamenAnalytiqueBilan;
